/**
 * Returns the document object associated with a given DOM node.
 *
 * @param {Node | null | undefined} node - The DOM node to retrieve the document for. If null or undefined, defaults to the global document.
 * @returns {Document} The document object associated with the given node, or the global document if none is found.
 */
export function ownerDocument(node) {
  return (node && node.ownerDocument) || document;
}
